import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Transfer from "../types/Transfer";

type Output = Transfer;

export default function useTransferInfoGet (
    uuid: any,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["transfer-info", uuid],
        () => {
            return client.get<any>(`transfers/` + uuid);
        },
        options
    );
}